import { useContext, useEffect } from "react";
import { WidgetContext } from "../../context/widgetContext";
import HtmlParsedText from "../common/HtmlParsedText";
import { ForumContext, ForumProvider } from "../../context/forumContext";
import { ForumStatisticsProvider } from "../../context/forumStatisticsContext";
import Body from "../common/Body";
import { boardUrl, TITLE } from "../../config/config";
import { Helmet } from "react-helmet";
import { generateHeadTags } from "react-seo-tools";
import ThreadListPromote from "./ForumView/ThreadListPromote";
import ThreadList from "./ForumView/ThreadList";
import LoadingContent from "../common/LoadingContent";
import {useParams} from "react-router-dom";
import LoadingNoMoreContent from "../common/LoadingNoMoreContent";

const SidebarContent = () => {
	const { tag_cloud, fetchWidgetHtml } = useContext(WidgetContext);

	useEffect(() => {
		fetchWidgetHtml("tag_cloud");
	}, [fetchWidgetHtml]);

	return (
		<>
			<div className="mb-4">
				{tag_cloud && <HtmlParsedText text={tag_cloud} />}
			</div>
		</>
	);
};

const HeroContent = () => {
	const { forum } = useContext(ForumContext);

	if (forum) {
		return (
			<div className="px-2 pt-2 md:px-4 md:pt-4">
				<div className="block items-center text-white mb-2 lg:flex">
					<div>
						<h1 className="text-lg font-medium text-white">{forum.title}</h1>
						<p className="text-sm text-url">{forum.description}</p>
					</div>

					<div className="inline-flex items-center gap-x-2 ml-auto">
						<a href={`${boardUrl}/index.php?forums/${forum.node_id}/create-thread`} className="button button--cta" rel="nofollow">
							<span className="button-text">Đăng bài…</span>
						</a>
					</div>
				</div>
			</div>
		);
	} else {
		return null;
	}
};

const MainContent = () => {
	const {
		forum,
		slide_premium,
		slide,
		stickyThreads,
		threads,
		pagination,
		handlePageChange,
		threadsPage,
		threadsLoading
	} = useContext(ForumContext);

	useEffect(() => {
		if (forum) {
			document.title = `${forum.title} | ${TITLE}`;
			document.querySelector('meta[name="description"]').setAttribute("content", forum.description);
		}
	}, [forum]);

	return (
		<div>
			{forum && (
				<Helmet>
					{generateHeadTags({
						title: forum.title,
						description: forum.description,
						openGraph: {
							type: "website",
							title: forum.title,
						},
					})}
				</Helmet>
			)}

			{forum && forum.type_data.is_promote ? (
				<>
					{slide_premium && threadsPage === 1 && (
						<div className="mb-4">
							<ThreadListPromote title="Slide Premium Threads" threads={slide_premium.threads} loading={threadsLoading} />
						</div>
					)}

					{slide && threadsPage === 1 && (
						<div className="mb-4">
							<ThreadListPromote title="Slide Threads" threads={slide.threads} loading={threadsLoading} />
						</div>
					)}

					{stickyThreads && threadsPage === 1 && (
						<div className="mb-4">
							<ThreadListPromote title="Sticky Threads" threads={stickyThreads} loading={threadsLoading} />
						</div>
					)}

					<div className="mb-4">
						{threads && threads.length > 0 ? (
							<ThreadListPromote
								title={threadsPage === 1 ? "Normal Threads" : `Normal Threads | Trang ${threadsPage}`}
								threads={threads}
								currentPage={threadsPage}
								pageCount={pagination.last_page}
								onPageChange={handlePageChange}
								loading={threadsLoading}
							/>
						) : (
							<div>
								{threadsLoading ? (
									<LoadingContent />
								) : (
									<LoadingNoMoreContent />
								)}
							</div>
						)}
					</div>
				</>
			) : (
				<>
					<div className="mb-4 border border-borderColor rounded-lg">
						{stickyThreads && <ThreadList threads={stickyThreads} loading={threadsLoading} />}

						<hr className="border-dashed" />

						{threads && threads.length > 0 ? (
							<ThreadList
								threads={threads}
								currentPage={threadsPage}
								pageCount={pagination.last_page}
								onPageChange={handlePageChange}
								loading={threadsLoading}
							/>
						) : (
							<div>
								{threadsLoading ? (
									<LoadingContent />
								) : (
									<LoadingNoMoreContent />
								)}
							</div>
						)}
					</div>
				</>
			)}
		</div>
	);
};

const ForumViewRender = () => {
	return <MainContent />;
};

const ForumView = () => {
	return (
		<ForumProvider>
			<ForumStatisticsProvider>
				<Body mainContent={<ForumViewRender />} heroContent={<HeroContent />} sidebarContent={<SidebarContent />} />
			</ForumStatisticsProvider>
		</ForumProvider>
	);
};

export default ForumView;
